"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactIntl = require("react-intl");
var messages = (0, _reactIntl.defineMessages)({
  ok: {
    "id": "ok",
    "defaultMessage": "OK"
  },
  checklistsDisabled: {
    "id": "checklistsDisabled",
    "defaultMessage": "Checklist disabled"
  },
  checklistsDisabledSubtitle: {
    "id": "checklistsDisabledSubtitle",
    "defaultMessage": "Checklists are disabled on your platform. You will not be able to complete and submit any results."
  },
  checklistsContactAdmin: {
    "id": "checklistsContactAdmin",
    "defaultMessage": "Please contact the platform admin if you need access to this feature."
  }
});
var _default = exports["default"] = messages;
//# sourceMappingURL=messages.js.map